module.exports = __webpack_public_path__ + "media/images/home/blue-rounded-background-cda635eab58c510859223febbbe13cd0.svg";